import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon } from 'ui';

const Rating = props => {
  const {
    rating,
    position,
    score,
    setHoverCount,
    hoverCount,
    setScore,
    disabled = false,
  } = props;

  const newIconStyles = classNames('CriteriaList-newRatingIcon', {
    'CriteriaList-newRatingIcon--active': Number(position) === Number(score),
    'CriteriaList-newRatingIcon--hover':
      Number(position) === Number(hoverCount) &&
      Number(position) !== Number(score),
  });

  const generateNewIconName = () => {
    switch (position) {
      case 1:
        return 'rating-warn';
      case 2:
        return 'rating-wrench';
      case 3:
        return 'rating-check';
      case 4:
        return 'rating-thumbs-up';
      case 5:
        return 'rating-trophy';
      default:
        return 'rating-check';
    }
  };

  const iconName = generateNewIconName();
  return (
    <div
      className={newIconStyles}
      data-toggle="tooltip"
      data-placement="top"
      data-delay="300"
      title={rating.description}
      onMouseOver={() => setHoverCount(position)}
      onFocus={() => setHoverCount(position)}
      onMouseLeave={() => setHoverCount(0)}
      onKeyDown={
        disabled ? _ => {} : e => e.key === 'Enter' && setScore(position)
      }
      onClick={disabled ? _ => {} : () => setScore(position)}
      disabled={disabled}
    >
      <Icon name={iconName} />
    </div>
  );
};

Rating.propTypes = {
  rating: PropTypes.shape({
    description: PropTypes.string,
    score: PropTypes.number,
  }),
  setScore: PropTypes.func,
  score: PropTypes.number,
  hoverCount: PropTypes.number,
  setHoverCount: PropTypes.func,
  position: PropTypes.number,
};

export default Rating;
